module.exports = __webpack_public_path__ + "img/073674.dbda3faf.png";